// src/components/productPage/tableComponents/ProductsBreadCrumbs.tsx
import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import MuiLink from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useBreadcrumbsFromNavigationPath } from '../../common/BreadCrumbs';
import * as styles from './ProductPage_style';

export interface BreadCrumb {
    name: string;
    url?: string;
}

interface ProductsBreadCrumbsProps {
    breadCrumbs?: BreadCrumb[];
}

export default function ProductsBreadCrumbs({ breadCrumbs }: ProductsBreadCrumbsProps) {
    const pimcoreHomeCrumb = useBreadcrumbsFromNavigationPath('/Home')[0];

    const home = (
        <MuiLink underline="hover" key="home" sx={styles.breadCrumbs_font} href="/">
            {pimcoreHomeCrumb?.name || 'Home'}
        </MuiLink>
    );

    const tail =
        breadCrumbs?.map((crumb, index) => {
            const isLast = index === (breadCrumbs?.length ?? 0) - 1;
            const sx = isLast ? styles.breadCrumbs_font2 : styles.breadCrumbs_font;
            const key = `${crumb.name}-${index}`;

            if (crumb.url && crumb.url.trim() !== '') {
                return (
                    <MuiLink underline="hover" key={key} sx={sx} href={crumb.url}>
                        {crumb.name}
                    </MuiLink>
                );
            }

            // 沒有 url：用 span，避免 <a href="">
            return (
                <span key={key} style={sx as React.CSSProperties}>
                    {crumb.name}
                </span>
            );
        }) || [];

    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={styles.breadCrumbs_font2}
        >
            {[home, ...tail]}
        </Breadcrumbs>
    );
}
